export default {
  "contact": "ಸಂಪರ್ಕಿಸಿ",
  "us": "ನಮ್ಮನ್ನು",
  "contact_description": "ಯಾವುದಾದರೂ ಪ್ರಶ್ನೆ, ಅಭಿಪ್ರಾಯ ಅಥವಾ ವೈಯಕ್ತಿಕ ಜ್ಯೋತಿಷ್ಯ ಸಲಹೆ ಬೇಕಾದರೆ? ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ – ನಾವು 24–48 ಗಂಟೆಗಳಲ್ಲಿ ಉತ್ತರಿಸುತ್ತೇವೆ.",

  "email": "ಇಮೇಲ್",
  "phone_whatsapp": "ದೂರವಾಣಿ / ವಾಟ್ಸಾಪ್",
  "chat_on_whatsapp": "ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ಚಾಟ್ ಮಾಡಿ",
  "follow_us": "ನಮ್ಮನ್ನು ಅನುಸರಿಸಿ",

  "full_name": "ಪೂರ್ಣ ಹೆಸರು",
  "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
  "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
  "subject": "ವಿಷಯ",
  "message": "ಸಂದೇಶ",

  "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
  "email_placeholder": "you@email.com",
  "phone_placeholder": "ಐಚ್ಛಿಕ: +91 xxxxx-xxxxx",
  "subject_placeholder": "ನಾವು ನಿಮಗೆ ಹೇಗೆ ಸಹಾಯ ಮಾಡಬಹುದು?",
  "message_placeholder": "ನಿಮ್ಮ ಜ್ಯೋತಿಷ್ಯ ಅಗತ್ಯಗಳಿಗೆ ನಾವು ಹೇಗೆ ಸಹಾಯ ಮಾಡಬಹುದು ಎಂಬುದನ್ನು ನಮಗೆ ತಿಳಿಸಿ...",

  "send_message": "ಸಂದೇಶ ಕಳುಹಿಸಿ",
  "message_sent_success": "ಸಂದೇಶ ಕಳುಹಿಸಲಾಗಿದೆ! ✓",
  "thank_you_message": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿದ್ದಕ್ಕೆ ಧನ್ಯವಾದಗಳು! ನಾವು 24–48 ಗಂಟೆಗಳಲ್ಲಿ ಪ್ರತಿಕ್ರಿಯೆ ನೀಡುತ್ತೇವೆ."
};
